import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import sl from "./sl.json"


const resources = {
    sl: {
        translation: sl,
    },
};

i18n.use(initReactI18next).use(initReactI18next).init({
    resources,
    compatibilityJSON: 'v4',
    fallbackLng: "sl",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
